import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import BalloonContainer from '../game/BalloonContainer';
import BonusBalloon from '../game/BonusBalloon';
import MrBee from '../game/MrBee';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import BonusHUD from '../ui/BonusHUD';
import ClickPointCircle from '../ui/ClickPointCircle';
import UIAssetKeys from '../UIAssetKeys';
import ResultsScreen from './ResultsScreen';

export default class BonusScreen extends Phaser.Scene {
  static get KEY() { return 'BonusScreen'; }

  constructor() {
    super({ key: BonusScreen.KEY });
  }

  init() {
    this.mrbee = null;
    this.stingOffsetX = 35;
    this.stingOffsetY = 40;

    this.balloons = null;

    /** @type {BonusBalloon[]} */
    this.activeBalloons = null;
    this.balloonWord = null;

    this.hill = null;

    this.hud = null;

    this.spawnDestPt = null;
    this.spawnWait = 0;
    this.spawnWaiter = 0;

    this.isOdd = false;

    this.music = null;

    this.popCount = 0;
    this.wrongCount = 0;
    this.wrongPops = null;

    this.gameOver = false;
  }

  create() {
    this.bg = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._MainBackground, this).setOrigin(0);

    this.wrongPops = [];
    this.spawnDestPt = { x: 0,y: 0 };

    this.clickArea = this.add.zone(0,0,this.scale.width, this.scale.height - 180).setOrigin(0)
      .setInteractive();

    this.hill = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Hill, this).setOrigin(0);
    this.initBalloons(20);
    this.initBee();

    this.hill.y = this.scale.height - this.hill.height;

    this.children.bringToTop(this.hill);

    this.isOdd = Phaser.Math.Between(0,100) < 50;
    if (this.isOdd) {
      gameData.userData.bonusResults.bonusType = 'Odd';
    }
    else {
      gameData.userData.bonusResults.bonusType = 'Even';
    }

    this.hud = new BonusHUD(this, this.isOdd);
    this.add.existing(this.hud);

    this.clickArea.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.clickScreen, this);

    this.clickDisplay = new ClickPointCircle(this);
    this.clickDisplay.x = -200;
    this.clickDisplay.y = -200;
    this.add.existing(this.clickDisplay);
    this.music = ABCyaPhaser.Audio.createSound(this);
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._cloud_walking_60, this.music, 1, true);
  }

  initBalloons (num) {
    this.balloonWorld = new BalloonContainer(this);
    this.add.existing(this.balloonWorld);
    this.balloonContainer = this.add.container();
    this.balloons = [];
    this.activeBalloons = [];
    let x = 0; let y = 0;
    const len = num; let b = null;
    for (let i = 0; i < len; i++) {
      x = this.scale.width / 2;
      y = this.scale.height - this.hill.height + Phaser.Math.Between(150,180);
      b = new BonusBalloon(this, this.balloonWorld, x, y);
      b.balloonTop.on('BALLOON_FINISHED', this.balloonSelfRemove, this);
      b.pos.x = x;
      b.pos.y = y;
      this.balloons.push(b);
    }
  }

  balloonSelfRemove (e) {
    this.deactivateBalloon(e.balloon);
  }

  deactivateBalloon (item) {
    const index = this.activeBalloons.indexOf(item);
    // eslint-disable-next-line no-param-reassign
    item.attractor.x = item.pos.x;
    // eslint-disable-next-line no-param-reassign
    item.attractor.y = item.pos.y;
    const b = this.activeBalloons.splice(index,1);
    if (b.length >= 1) {
      this.balloons.push(item);
    }
  }

  initBee () {
    this.mrbee = new MrBee(this, true);
    this.mrbee.on('ARRIVED', this.beeAtPoint, this);
    this.mrbee.on('STING', this.beeStingOver, this);
    const mrBeeBounds = this.mrbee.getBounds();
    this.mrbee.list.forEach((child) => {
      child.setPosition(child.x - mrBeeBounds.width / 2, child.y - mrBeeBounds.height / 2);
    });
    const x = -50;
    const y = 380;
    this.mrbee.pos.x = x;
    this.mrbee.pos.y = y;
    this.mrbee.initForceMove(100,y - Phaser.Math.Between(10,22));
    this.mrbee.x = x;
    this.mrbee.y = y;
    this.mrbee.turn(-1);
    this.add.existing(this.mrbee);
  }

  beeAtPoint () {
    if (this.balloonWorld.balloonToPop) {
      this.popCount++;
      if (this.balloonWorld.balloonToPop.isGood) {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._balloon_expand, this);
        this.balloonWorld.balloonToPop.pop();
      }
      else {
        this.balloonWorld.balloonToPop.deflate();
        this.wrongCount++;
        if (this.wrongPops.indexOf(this.balloonWorld.balloonToPop.num) < 0) {
          this.wrongPops.push(this.balloonWorld.balloonToPop.num);
        }
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._deflate, this);
      }
      this.balloonWorld.balloonToPop = null;
      this.mrbee.doSting();
    }
    else {
      this.mrbee.initForceMove(this.mrbee.pos.x + Phaser.Math.Between(5,10) - 10, this.mrbee.pos.y + Phaser.Math.Between(5,10) - 10);
    }
  }

  beeStingOver () {
    this.mrbee.initForceMove(this.mrbee.pos.x, this.mrbee.pos.y);
  }

  timesUp () {
    this.gameOver = true;
    this.mrbee.off('ARRIVED');
    this.mrbee.off('STING');
    this.mrbee.initMoveTo(this.scale.width + 600, this.mrbee.pos.y + Phaser.Math.Between(1,60), 60);
    const len = this.activeBalloons.length;
    for (let i = 0; i < len; i++) {
      if (this.activeBalloons[i].isAlive) {
        this.activeBalloons[i].deflate(800);
      }
    }
    ABCyaPhaser.Tweens.addTween(this.hud, 550, { alpha: 0 }, Phaser.Math.Easing.Linear);
    this.time.delayedCall(860, this.nextScene, null, this);
  }

  nextScene () {
    this.sound.stopAll();
    this.music.destroy();
    this.music = null;
    gameData.userData.bonusResults.wrongPops = this.wrongPops.slice();
    if (this.wrongPops.length === 0) {
      gameData.userData.bonusResults.score = 100;
    }
    else {
      gameData.userData.bonusResults.score = ((this.popCount - this.wrongPops.length) / this.popCount) * 100;
    }
    gameData.gameInfo.currentRound++;
    this.scene.start(ResultsScreen.KEY, { resultType: 'BONUS' });
  }

  clickScreen (pointer) {
    if (this.gameOver) return;
    const x = pointer.x;
    const y = pointer.y;
    let destX = x;
    let destY = y;

    // check for a balloon hit
    const len = this.activeBalloons.length;
    let found = false;
    if (this.balloonWorld.balloonToPop) {
      this.balloonWorld.balloonToPop.initFloatTo(this.balloonWorld.balloonToPop.pos.x, -430);
    }

    for (let i = 0; i < len; i++) {
      if (this.activeBalloons[i].isAlive && this.activeBalloons[i].checkHit(x,y)) {
        if (this.balloonWorld.balloonToPop) {
          this.balloonWorld.balloonToPop.initFloatTo(this.balloonWorld.balloonToPop.pos.x, -130);
        }
        this.balloonWorld.balloonToPop = this.activeBalloons[i];
        this.activeBalloons[i].initHoverFloat(this.activeBalloons[i].pos.x - 10, this.activeBalloons[i].pos.y + 10);
        destX = this.activeBalloons[i].pos.x;
        destY = this.activeBalloons[i].pos.y - this.stingOffsetY;
        const dir = this.mrbee.pos.x - this.activeBalloons[i].pos.x;
        if (dir < 0) {
          destX += this.stingOffsetX;
        }
        else {
          destX -= this.stingOffsetX;
        }

        found = true;
        break;
      }
    }
    if (!found) {
      this.balloonWorld.balloonToPop = null;
    }

    this.mrbee.initMoveTo(destX, destY, 60);
    this.clickDisplay.displayClick(x,y);
  }

  spawnBalloon () {
    const num = Phaser.Math.Between(0,9);
    let isgood = false;
    if (this.isOdd) {
      if (num % 2) isgood = true;
    }
    else {
      if (!(num % 2)) isgood = true;
    }
    const b = this.balloons.pop();
    this.spawnDestPt.x = Phaser.Math.Between(50, this.scale.width - 50);
    this.spawnDestPt.y = -Phaser.Math.Between(320,380);
    b.pos.x = this.spawnDestPt.x - Phaser.Math.Between(40,42);
    b.x = b.pos.x;
    b.pos.y = this.scale.height - this.hill.height + Phaser.Math.Between(150,180);
    b.y = b.pos.y;
    const colorid = Phaser.Math.Between(1,5);
    b.reset(b.x, b.y, colorid, num, isgood);
    b.initFloatTo(this.spawnDestPt.x, this.spawnDestPt.y);
    this.activeBalloons.push(b);
  }

  update(time, delta) {
    const d = delta / 1000;
    this.mrbee.tick(d);
    const len = this.activeBalloons.length - 1;
    for (let i = len; i >= 0; i--) {
      if (!this.activeBalloons[i].isActive) {
        this.deactivateBalloon(this.activeBalloons[i]);
        continue;
      }
      this.activeBalloons[i].tick(d);
      if (this.activeBalloons[i].pos.y < -130) {
        this.deactivateBalloon(this.activeBalloons[i]);
      }
    }

    if (this.gameOver) return;
    this.hud.tick(d);
    if (this.spawnWaiter <= 0) {
      this.spawnBalloon();
      this.spawnWaiter = Phaser.Math.Between(6,9) * 0.1;
    }
    else {
      this.spawnWaiter -= d;
    }
  }
}